import React from 'react';
import PropTypes from 'prop-types';
import { ReactTemplate } from '@bingads-webui-react/react-template';

export const BoldSyntax = props =>
  (<ReactTemplate
    model={{
            b: text => (<b>{text}</b>),
          }}
    template={props.template}
  />);

BoldSyntax.propTypes = {
  template: PropTypes.string.isRequired,
};

